function closeMiniCart() {
  var miniCart = document.getElementById("mini-cart");
  if (miniCart.hasAttribute("open")) {
    miniCart.removeAttribute("open");
  }
}

$(document).on("click", ".tab-set-unique1 .tab-link", function () {
  var tabId = $(this).data("tab");
  var tabSet = $(this).closest(".tab-set");

  tabSet.find(".tab-link").removeClass("active");
  tabSet.find(".tab-content").hide();
  $(".hidde-burger-slider").hide();
  $(".slider-" + tabId).show();
  $(this).addClass("active");

  $("#" + tabId).fadeIn();
});

// Function to update the variant ID and image
function updateVariantIdAndImage(productForm) {
  const productData = JSON.parse(productForm.dataset.productJson);
  const selectedOptions = [];

  // Collect selected options
  productData.options.forEach((option, index) => {
    const select = productForm.querySelector(`select[name="option-${index}"]`);
    selectedOptions.push(select.value);
  });

  // Find the matching variant
  const matchingVariant = productData.variants.find((variant) => {
    return variant.options.every(
      (option, index) => option === selectedOptions[index]
    );
  });

  // Get elements once
  const productItem = productForm.closest(".product-item");
  const imageElement = productItem.querySelector(".product-image img");
  const addToCartButton = productForm.querySelector(".add-to-cart-button");
  const soldOutBadge = productForm.querySelector(".sold-out-badge");

  if (matchingVariant) {
    productForm.querySelector(".variant-id").value = matchingVariant.id;

    // Update image if available
    if (
      matchingVariant.featured_media &&
      matchingVariant.featured_media.preview_image &&
      matchingVariant.featured_media.preview_image.src
    ) {
      if (
        imageElement.src !== matchingVariant.featured_media.preview_image.src
      ) {
        imageElement.src = matchingVariant.featured_media.preview_image.src;
      }
    }

    // Update button state
    if (matchingVariant.available) {
      addToCartButton.classList.remove("not-available-variant");
      addToCartButton.classList.add("available-variant");
      addToCartButton.disabled = false;
      soldOutBadge.style.display = "none";
    } else {
      addToCartButton.classList.remove("available-variant");
      addToCartButton.classList.add("not-available-variant");
      addToCartButton.disabled = true;
      soldOutBadge.style.display = "inline";
    }
  } else {
    productForm.querySelector(".variant-id").value = "";
    imageElement.src = productData.featured_image.src;

    addToCartButton.classList.remove("available-variant");
    addToCartButton.classList.add("not-available-variant");
    addToCartButton.disabled = true;
    soldOutBadge.style.display = "inline";
  }

  console.log("Variant update completed");
}

// Function to handle onchange event
function myFunction(selectElement) {
  // Find the closest product form from the select element
  const productForm = selectElement.closest(".product-form");

  // Call the update function
  updateVariantIdAndImage(productForm);
}

// document.addEventListener("DOMContentLoaded", (event) => {
//   setupRatingSnippet();
//   setTimeout(function () {
//     setupRatingSnippet();
//   }, 500); // Delay for 1 second
// });

// setupRatingSnippet();
// document.addEventListener("cart:refresh", function (event) {
//   setTimeout(function () {
//     setupRatingSnippet();
//   }, 300); // Delay for 1 second
// });

// Select elements
const versandOpenPopupBtn = document.getElementById("versand-open-popup");
const versandClosePopupBtn = document.getElementById("versand-close-popup");
const versandPopup = document.getElementById("versand-popup");
const versandPopupOverlay = document.getElementById("versand-popup-overlay");
const versandBody = document.body;

// Function to open the popup
function versandOpenPopup() {
  versandPopup.style.display = "block";
  versandPopupOverlay.style.display = "block";
  versandBody.classList.add("versand-no-scroll"); // Disable scrolling on body
}

// Function to close the popup
function versandClosePopup() {
  versandPopup.style.display = "none";
  versandPopupOverlay.style.display = "none";
  versandBody.classList.remove("versand-no-scroll"); // Enable scrolling on body
}

if (versandOpenPopupBtn) {
  versandOpenPopupBtn.addEventListener("click", versandOpenPopup);
}

if (versandClosePopupBtn) {
  versandClosePopupBtn.addEventListener("click", versandClosePopup);
}

if (versandPopupOverlay) {
  versandPopupOverlay.addEventListener("click", versandClosePopup);
}

function checkClassOnSelectedMedia() {
  if ($(".product__media-item.is-selected").hasClass("info-bar-active")) {
    $(".custom-lines-only").removeClass("lines-present");
    $(".custom-arrow-only").removeClass("lines-present-2");
  } else {
    $(".custom-lines-only").addClass("lines-present");
    $(".custom-arrow-only").addClass("lines-present-2");
  }
}

checkClassOnSelectedMedia();

// Overflow-Scroller for CP Swatches
document.addEventListener("DOMContentLoaded", function () {
  // Funktion, um zu überprüfen, ob ein Element überläuft
  function hasOverflow(element) {
    return element.scrollWidth > element.clientWidth;
  }

  const elements = document.querySelectorAll(
    ".product-item-meta__variation-products .inner"
  );

  elements.forEach((element) => {
    if (hasOverflow(element)) {
      element.classList.add("has-overflow");
    }
  });
});

// const sliders = document.querySelectorAll('.product-item-meta__variation-products .inner');

// sliders.forEach(slider => {
//     let isDown = false;
//     let startX;
//     let scrollLeft;

//     slider.addEventListener('mousedown', (e) => {
//         isDown = true;
//         slider.classList.add('active');
//         startX = e.pageX;
//         scrollLeft = slider.scrollLeft;
//     });

//     slider.addEventListener('mouseleave', () => {
//         isDown = false;
//         slider.classList.remove('active');
//     });

//     slider.addEventListener('mouseup', () => {
//         isDown = false;
//         slider.classList.remove('active');
//     });

//     slider.addEventListener('mousemove', (e) => {
//         if (!isDown) return;  // Stop the function from running if not clicked
//         e.preventDefault();
//         const x = e.pageX - startX;
//         slider.scrollLeft = scrollLeft - x * 2;  // Adjust scrolling speed by multiplying
//     });
// });

/* Image Switch on CP */
/* -------------------------------------------
   Event Delegation for Swatch Click (Image & Price)
   Ensures functionality persists after AJAX/Pagination
------------------------------------------- */

// Attach a single click listener to the entire document.
document.addEventListener("click", function(event) {
  
  // Use .closest() to check if the clicked element (or one of its parents) 
  // is the target swatch link class.
  const item = event.target.closest(".product-item .color-relations .variant-swatch__item");

  if (!item) {
    // If the click did not originate from a swatch, stop.
    return;
  }
  
  // If a swatch was clicked, prevent default link behavior.
  event.preventDefault();

  const productItem = item.closest(".product-item");
  if (!productItem) return;

  // Update Active State
  productItem
    .querySelectorAll(".variant-swatch__item.active")
    .forEach((activeItem) => {
      activeItem.classList.remove("active");
    });
  item.classList.add("active");

  // Update Images
  const primaryImage = productItem.querySelector(
    ".product-item__image-wrapper .product-item__primary-image"
  );
  const secondaryImage = productItem.querySelector(
    ".product-item__image-wrapper .product-item__secondary-image"
  );
  
  const newPrimarySrc = item.getAttribute("data-primary-image");
  const newSecondarySrc = item.getAttribute("data-secondary-image");

  if (primaryImage) {
    if (newPrimarySrc && newPrimarySrc !== "none") {
      primaryImage.setAttribute("src", newPrimarySrc);
      primaryImage.setAttribute("srcset", newPrimarySrc);
    } else if (newSecondarySrc) {
      primaryImage.setAttribute("src", newSecondarySrc);
      primaryImage.setAttribute("srcset", newSecondarySrc);
    }
  }

  if (secondaryImage && newSecondarySrc) {
    secondaryImage.setAttribute("src", newSecondarySrc);
    secondaryImage.setAttribute("srcset", newSecondarySrc);
  }

  // Update URLs
  const variantUrl = item.getAttribute("data-variant-url");
  if (variantUrl) {
    const imageWrapperLink = productItem.querySelector(
      ".product-item__image-wrapper a"
    );
    const metaLink = productItem.querySelector(".product-item-meta a");

    if (imageWrapperLink) {
      imageWrapperLink.setAttribute("href", variantUrl);
    }
    if (metaLink) {
      metaLink.setAttribute("href", variantUrl);
    }
  }

  // Update Price and Savings
  const newPrice = item.getAttribute("data-price");
  const newCompareAtPrice = item.getAttribute("data-compare-at-price");
  const newSavings = item.getAttribute("data-savings");
  
  // Get the current language code from the HTML tag (e.g., 'en', 'de', 'fr')
  const lang = document.documentElement.getAttribute("lang");
  
  // Determine the correct savings text based on the language
  let savingsText;
  if (lang && lang.startsWith("de")) {
      savingsText = "du sparst";
  } else {
      // Default to "you save" for all other languages (en, fr, etc.)
      savingsText = "you save"; 
  }

  const priceListContainer = productItem.querySelector(".price-list");
  if (priceListContainer && newPrice) {
    let newPriceHTML = "";
    
    // Check for discount structure: if compare price exists AND has content
    if (newCompareAtPrice && newCompareAtPrice.trim().length > 0) {
      newPriceHTML = `
        <span class="price price--highlight">
          <span class="visually-hidden">Angebotspreis</span>
          ${newPrice}
        </span>
        <span class="price price--compare">
          <span class="visually-hidden">Regulärer Preis</span>
          ${newCompareAtPrice}
        </span>
        <span class="label label--highlight">
          <span class="ed-save-amount">${savingsText} ${newSavings}</span>
        </span>
      `;
    } else {
      newPriceHTML = `
        <span class="price">
          <span class="visually-hidden">Angebotspreis</span>
          ${newPrice}
        </span>
      `;
    }
    
    priceListContainer.innerHTML = newPriceHTML;
  }
});


/* Fix - color swatch redirecting after selecting color from filter */

document.addEventListener('DOMContentLoaded', function() {
  // find the static parent element that contains the product grid.
  const productGrid = document.querySelector('#facet-main');

  // if the grid exists, add a single click listener to it.
  if (productGrid) {
    productGrid.addEventListener('click', function(event) {
      // Use .closest() to check if the clicked element (or one of its parents) is a variant swatch link.
      const swatchLink = event.target.closest('.variant-swatch__item');

      // If a swatch link was not clicked, do nothing.
      if (!swatchLink) {
        return;
      }

      // 1. Prevent the link from redirecting the page.
      event.preventDefault();

      // Find the main product item card that this swatch belongs to.
      const productItem = swatchLink.closest('.product-item');
      if (!productItem) {
        return;
      }
      
      // 2. Get the new image URLs from the clicked swatch's data attributes.
      const newPrimaryImageUrl = swatchLink.dataset.primaryImage;
      const newSecondaryImageUrl = swatchLink.dataset.secondaryImage;
      const newVariantUrl = swatchLink.dataset.variantUrl;

      // 3. Find the images and links to update within the product card.
      const primaryImage = productItem.querySelector('.product-item__primary-image');
      const secondaryImage = productItem.querySelector('.product-item__secondary-image');
      const productLink = productItem.querySelector('.product-item-meta__title');
      const imageLink = productItem.querySelector('.product-item__aspect-ratio');


      // 4. Update the images and links.
      if (primaryImage && newPrimaryImageUrl && newPrimaryImageUrl !== 'none') {
        primaryImage.src = newPrimaryImageUrl;
        primaryImage.srcset = newPrimaryImageUrl; // Or construct a proper srcset if needed
      }
      
      // The secondary image in your code is the first one, which is hidden/shown on hover.
      if (secondaryImage && newSecondaryImageUrl) {
        secondaryImage.src = newSecondaryImageUrl;
        secondaryImage.srcset = newSecondaryImageUrl;
      }
      
      // Update the main product and image links to point to the new variant.
      if (productLink && newVariantUrl) {
          productLink.href = newVariantUrl;
      }
      if (imageLink && newVariantUrl) {
          imageLink.href = newVariantUrl;
      }

      // 5. Update the "active" state on the swatches.
      const allSwatchesInCard = productItem.querySelectorAll('.variant-swatch__item');
      allSwatchesInCard.forEach(swatch => swatch.classList.remove('active'));
      swatchLink.classList.add('active');

    });
  }
});

// --- FOOTER ACCORDION LOGIC FIX ---
$('.footer-accordian').on('click', function () {
    $(this).toggleClass('active');
    
    // NOTE: If this fails, try changing 'forloop' to 'data-target' 
    // and updating your HTML to use data-target="#id" on the accordion header.
    var targetSelector = $(this).attr('forloop'); 
    
    if (targetSelector) {
        $(targetSelector).slideToggle();
    }
});